import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e53e22bc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ltv-composite-bar"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.values, value => {
    return _openBlock(), _createElementBlock("div", {
      style: _normalizeStyle($options.computedStyle(value))
    }, null, 4);
  }), 256))]);
}